import React from "react";
import {
    Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import axios from "axios";
import { baseUrl } from "../config";


const LogoutConfirmation = ({ open, onClose }) => {


    const navigate = useNavigate();

    const { setIsLoggedIn } = useAuth();
    const { logout } = useAuth();

    const handleLogout = async () => {
        logout();
        try {
            await axios.post(baseUrl + "/logout");
            setIsLoggedIn(false);
            setTimeout(() => {
                navigate("/login");
            }, 1000); // Redirect
        } catch (error) {
            console.error("Logout error:", error);
        }
    };
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="confirm-logout-title"
        >
            <DialogTitle id="confirm-logout-title">Confirmer la déconnexion</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Es-tu sûr de vouloir te déconnecter ?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Annuler
                </Button>
                <Button
                    onClick={handleLogout}
                    color="error"
                    variant="contained"
                >
                    Se déconnecter
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default LogoutConfirmation;